module.exports = __webpack_public_path__ + "static/img/akum_800_320.c55fb7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_320.svg
// module id = IsDF
// module chunks = 1